<template>
  <div>
    <b-alert :show="errors.any()" variant="danger" class="mb-2 py-2 px-4">
      <ul class="m-0 px-1">
        <li v-for="err in errors.all()" :key="err">{{err}}</li>
      </ul>
    </b-alert>

    <widget
      :type="widget.type"
      :title="widget.title"
      :subtitle="widget.subtitle"
      :url="widget.url"
      :availability="widget.availability"
      :viewData="widget.viewData"
      :view="widget.view"
      @update:type="widget.type = $event"
      @update:title="widget.title = $event"
      @update:subtitle="widget.subtitle = $event"
      @update:url="widget.url = $event"
      @update:availability="widget.availability = $event"
      @update:viewData="widget.viewData = $event"
      @update:view="widget.view = $event"
    >
      <b-row>
        <b-col md="6">
          <b-form-group class="mb-2 mb-md-0">
            <b-input-group>
              <b-input-group-prepend is-text>
                {{ $t('widgetAreas.component') }}
                <required-symbol/>
              </b-input-group-prepend>

              <b-form-input
                dir="auto"
                :name="$t('widgetAreas.component')"
                v-validate="'required'"
                v-model="widget.component"
              />
            </b-input-group>
          </b-form-group>
        </b-col>

        <b-col md="6">
          <b-form-group class="mb-0">
            <b-input-group :prepend="$t('widgetAreas.componentData')">
              <b-form-input
                dir="auto"
                v-model="widget.componentData"
              />
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>
    </widget>
  </div>
</template>

<script>
import EditorMixin from './EditorMixin'
import Widget from '../Widget'

export default {
  name: 'ComponentWidget',
  mixins: [EditorMixin],
  components: {
    Widget
  },
  watch: {
    widget: {
      handler (val) {
        this.emitTitle(val)
      },
      deep: true
    }
  },
  mounted () {
    this.emitTitle(this.widget)
  },
  methods: {
    emitTitle (widget) {
      let title

      if (widget.title)
        title = widget.title

      else if (widget.component)
        title = widget.component

      this.$emit('setTitle', title)
    }
  }
}
</script>
